/** 24×24 stroke icons. Every icon has a default size, so one can never grow to fill its container. */
const PATHS = {
  messages: 'M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.6A8 8 0 1 1 21 12z',
  calls: 'M6.5 3.5l3 4-2 2a12 12 0 0 0 7 7l2-2 4 3-1.5 3C11 21 3 13 3.5 5L6.5 3.5z',
  spaces: 'M4 4h6.5v6.5H4zM13.5 4H20v6.5h-6.5zM4 13.5h6.5V20H4zM13.5 13.5H20V20h-6.5z',
  calendar: 'M4 6.5A1.5 1.5 0 0 1 5.5 5h13A1.5 1.5 0 0 1 20 6.5v12a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18.5zM4 10h16M8.5 3v4M15.5 3v4',
  learn: 'M2.5 9 12 4.5 21.5 9 12 13.5zM6.5 11v4.5c3.5 2.5 7.5 2.5 11 0V11M21.5 9v5',
  discover: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm3.5 5.5-2 5-5 2 2-5 5-2z',
  ai: 'M12 3.5l1.8 4.7 4.7 1.8-4.7 1.8L12 16.5l-1.8-4.7L5.5 10l4.7-1.8zM18.5 15l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z',
  settings:
    'M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z',
  lock: 'M7 11V8a5 5 0 0 1 10 0v3M5.5 11h13v9.5h-13z',
  shield: 'M12 3l7.5 3v5.5c0 4.6-3.2 8.4-7.5 9.5-4.3-1.1-7.5-4.9-7.5-9.5V6z',
  user: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4.5 20.5a7.5 7.5 0 0 1 15 0',
  users: 'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM2.5 20a6.5 6.5 0 0 1 13 0M16 4.3a3.5 3.5 0 0 1 0 6.4M21.5 20a6.5 6.5 0 0 0-3.5-5.8',
  palette:
    'M12 3a9 9 0 1 0 0 18c1 0 1.5-.7 1.5-1.4 0-.9-.7-1.4-.7-2.3 0-1 .8-1.8 1.8-1.8H17a4 4 0 0 0 4-4C21 6.9 17 3 12 3zM7.5 12h.01M9.5 7.5h.01M14.5 7.5h.01',
  bell: 'M6 16v-5a6 6 0 1 1 12 0v5l1.5 2h-15zM10 20.5a2 2 0 0 0 4 0',
  key: 'M14.5 4a5.5 5.5 0 0 0-5.3 7L3 17.2V21h3.8v-2.2H9v-2.2h2.2l1.3-1.3A5.5 5.5 0 1 0 14.5 4zM16 8h.01',
  monitor: 'M3.5 4.5h17v11h-17zM8 20h8M12 15.5V20',
  flag: 'M5 21V4M5 4h11l-2 4 2 4H5',
  ticket: 'M3.5 7.5h17V10a2 2 0 0 0 0 4v2.5h-17V14a2 2 0 0 0 0-4zM10 7.5v9',
  activity: 'M3 12h4l3-7 4 14 3-7h4',
  sliders: 'M4 7h9M17 7h3M4 12h3M11 12h9M4 17h11M19 17h1M15 5v4M9 10v4M17 15v4',
  list: 'M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01',
  alert: 'M12 3.5 21.5 20h-19zM12 10v4M12 17h.01',
  logout: 'M15 4h3.5A1.5 1.5 0 0 1 20 5.5v13a1.5 1.5 0 0 1-1.5 1.5H15M10 8l-4 4 4 4M6 12h10',
  back: 'M15 5l-7 7 7 7',
  chevron: 'M9 6l6 6-6 6',
  plus: 'M12 5v14M5 12h14',
  search: 'M11 4.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13zM20 20l-4.4-4.4',
  star: 'M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z',
  send: 'M4 12 20 4l-6 16-3-7zM11 13l9-9',
  more: 'M12 5.5h.01M12 12h.01M12 18.5h.01',
  info: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 11v5M12 7.5h.01',
  template: 'M8 4h8v3H8zM6 5.5H5v15h14v-15h-1M8.5 11h7M8.5 14.5h7M8.5 18h4',
  phone: 'M6.5 3.5l3 4-2 2a12 12 0 0 0 7 7l2-2 4 3-1.5 3C11 21 3 13 3.5 5L6.5 3.5z',
  video: 'M3.5 7h11v10h-11zM14.5 10.5 20.5 7v10l-6-3.5',
  bellOff: 'M9 4.6A6 6 0 0 1 18 11v5l1.5 2M6 11v5L4.5 18H15M10 20.5a2 2 0 0 0 4 0M3 3l18 18',
  userPlus: 'M10 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM3 20.5a7 7 0 0 1 12.5-4.3M19 14v6M16 17h6',
  close: 'M6 6l12 12M18 6 6 18',
  attach: 'M21 11l-8.5 8.5a5 5 0 0 1-7-7L14 4a3.5 3.5 0 0 1 5 5l-8.5 8.5a2 2 0 0 1-3-3L15 7',
  mic: 'M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3zM5 11a7 7 0 0 0 14 0M12 18v3',
  file: 'M6 3h8l4 4v14H6zM14 3v4h4',
  stop: 'M7 7h10v10H7z',
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, label, size = 20 }: { name: IconName; label?: string; size?: number }) {
  return (
    <svg
      className="icon"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={label ? undefined : true}
      role={label ? 'img' : undefined}
      aria-label={label}
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
